import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';
import {
    GROUPS_STATUS_ACTIVE,
    GROUPS_STATUS_INACTIVE,
    GROUPS_TYPE_FACILITY,
    GROUPS_TYPE_IDN,
    GROUPS_TYPE_MAPPING,
    GROUPS_TYPE_PHARMACY,
} from '../../groups_const';

export type ColKey = '' | 'Entities' | 'State' | 'Name' | 'ObjectState' | 'Type';

function typeOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: GROUPS_TYPE_FACILITY, val: GROUPS_TYPE_FACILITY },
        { lbl: GROUPS_TYPE_IDN, val: GROUPS_TYPE_IDN },
        { lbl: GROUPS_TYPE_MAPPING, val: GROUPS_TYPE_MAPPING },
        { lbl: GROUPS_TYPE_PHARMACY, val: GROUPS_TYPE_PHARMACY },
    ];
}
function statusOptions(): TblFltOption[] {
    return [
        { lbl: 'ALL', val: '' },
        { lbl: GROUPS_STATUS_ACTIVE, val: GROUPS_STATUS_ACTIVE },
        { lbl: GROUPS_STATUS_INACTIVE, val: GROUPS_STATUS_INACTIVE },
    ];
}

// column spec (map the keys to the column types)
export function groupsListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'Name', { width: '60px' });
    tblSpecAddColumn<ColKey>(map, 'Type', { type: 'DROPTEXT', width: '60px', fltOptions: typeOptions() });
    tblSpecAddColumn<ColKey>(map, 'Entities', { width: '60px', title: 'Members' });
    tblSpecAddColumn<ColKey>(map, 'ObjectState', {
        type: 'DROPTEXT',
        title: 'Status',
        width: '40px',
        fltOptions: statusOptions(),
    });
    return map;
}

// default view
export function groupsListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Name',
                cols: ['Name'],
            },
            {
                title: 'Type',
                cols: ['Type'],
            },
            {
                title: 'Members',
                cols: ['Entities'],
            },
            {
                title: 'Status',
                cols: ['ObjectState'],
            },
        ],
        sortby: 'Name',
    };
}
